import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Button,
  Grid,
  SvgIcon,
  Typography,
} from '@material-ui/core';
import {
  X as XIcon,
  PlusCircle as PlusCircleIcon,
  Upload as UploadIcon,
  Download as DownloadIcon,
} from 'react-feather';

import { useSnackbar } from 'notistack';
import useStyles from './styles';
import {
  downloadEngelProductsFile,
  uploadEngelProductsFile,
} from '../../../requests/api/engelproducts';

function Header({
  className,
  cleanFilters,
  ...rest
}) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingUpload, setLoadingUpload] = useState(false);
  const fileInputRef = useRef(null);

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoadingUpload(true);
    enqueueSnackbar('Subiendo archivo...', {
      variant: 'info',
      autoHideDuration: 5000,
    });

    try {
      const response = await uploadEngelProductsFile(file);
      if (response.success) {
        enqueueSnackbar('Archivo subido exitosamente', {
          variant: 'success',
          autoHideDuration: 5000,
        });
      } else {
        enqueueSnackbar(response?.message || 'Error desconocido', {
          variant: 'error',
        });
      }
    } catch (error) {
      enqueueSnackbar('Error al subir el archivo', {
        variant: 'error',
      });
    } finally {
      setLoadingUpload(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  };

  const handleDownload = async () => {
    const response = await downloadEngelProductsFile();
    if (response?.data?.file) {
      const fileData = response.data.file;
      const { fileName } = response.data;
      const uri = `data:${'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'};charset=utf-8${';base64'},${fileData}`;
      const downloadLink = document.createElement('a');
      downloadLink.href = uri;
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  return (
    <Grid
      className={clsx(classes.rootHeader, className)}
      container
      justifyContent="space-between"
      spacing={3}
      alignItems="center"
      {...rest}
    >
      <Grid item xs={12} sm={6}>
        <Typography
          variant="h3"
          color="textPrimary"
        >
          Productos Engel
        </Typography>
      </Grid>
      <Grid item xs={6} sm={3} >
        <Button
          color="secondary"
          variant="contained"
          className={classes.action}
          onClick={() => cleanFilters()}
        >
          <SvgIcon
            fontSize="small"
            className={classes.actionIcon}
          >
            <XIcon />
          </SvgIcon>
          Limpiar filtros
        </Button>
      </Grid>
      <Grid item xs={6} sm={3}>
        <Button
          color="secondary"
          variant="contained"
          className={classes.action}
          href="/engel/engel-products/crear"
        >
          <SvgIcon
            fontSize="small"
            className={classes.actionIcon}
          >
            <PlusCircleIcon />
          </SvgIcon>
          Crear producto
        </Button>
      </Grid>
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={6} sm={2} className={classes.actionContainer}>
          <label htmlFor="upload-file">
            <input
              ref={fileInputRef}
              type="file"
              style={{ display: 'none' }}
              id="upload-file"
              name="upload-file"
              onChange={handleUpload}
            />
            <Button
              color="primary"
              variant="contained"
              className={classes.action}
              component="span"
              disabled={loadingUpload}
            >
              <SvgIcon
                fontSize="small"
                className={classes.actionIcon}
              >
                <UploadIcon />
              </SvgIcon>
              Subir archivo
            </Button>
          </label>
        </Grid>
        <Grid item xs={6} sm={2} className={classes.actionContainer}>
          <Button
            color="primary"
            variant="contained"
            className={classes.action}
            component="span"
            disabled={loadingUpload}
            onClick={handleDownload}
          >
            <SvgIcon
              fontSize="small"
              className={classes.actionIcon}
            >
              <DownloadIcon />
            </SvgIcon>
            Bajar archivo
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
  cleanFilters: PropTypes.func,
};

export default Header;
